import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    accessContext: {
    profile: {
      id: null,
      name: "",
    },
    user: {},
    roles: [],
    modulePermissions: [],
    fieldPermissions: [],
    userPermission: {}
  },
}

const userContext = createSlice({
    name: 'UserContext',
    initialState,
    reducers: {
        setAccessContext: (state, action) => {
            state.accessContext = action.payload;
        },
    }
});

export const {
  setAccessContext,
} = userContext.actions;

export default userContext.reducer;
